<article>
	<header>
		<cache-date></cache-date>
		
		<h3>Возвраты v1 (админка саппорта)</h3>
	</header>
	
	<section>
		<period></period>
		<hr/>
	</section>
	
	<section>
		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
	</section>
	
	<section>
		<chart
			[data]="returnChart.data"
			[options]="returnChart.options"
			(onFilterChange)="updateData($event, 'return')"
			[sextant]="'return'"
		></chart>
		
		<hr/>
	</section>
	
	<br/>

	<section>
		<h4>
			{{ 'adminstat.common.All count' | translate }}: {{ stats.length }}
		</h4>
		
		<h4>
			{{ 'adminstat.billing.manual_paid.totalMoney' | translate }}:
			{{ getTotalAmount() }} $
		</h4>
	</section>
	
	<section>
		<ngb-pagination [extlinks]="links" [collectionSize]="totalPages" [maxSize]="10" [pageSize]="1" [(page)]="currentPage" [boundaryLinks]="true" (pageChange)="onPageChange()" *ngIf="!paginationLoader"></ngb-pagination>
		<table class="table">
			<thead>
				<tr>
					<th>Дата возврата</th>
					<th>{{ 'adminstat.filterForm.datePaid' | translate }}</th>
					<th>{{ 'adminstat.common.Email' | translate }}&nbsp;/&nbsp;{{ 'adminstat.common.Site' | translate }}</th>
					<th>{{ 'adminstat.common.Money' | translate }}</th>
					<th>Параметры возврата</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let stat of stats;">
					<td>
						{{ stat.time | dateFormat:'DD.MM.YYYY HH:mm' }}
					</td>
					
					<td>
						{{ stat.transaction_date | dateFormat:'DD.MM.YYYY HH:mm' }}
					</td>
					
					<td>
						<gotosupport [value]="stat.email"></gotosupport>
						<br />
						<site_info [siteUrl]="stat.domainUrl"></site_info>
					</td>
					
					<td>
						${{ stat.usdAmount }}
					</td>
					
					<td>
						<ul>
							<li>
								supportName
								<span class="badge badge-pill badge-info">
									{{ stat.supportEmail }} ({{ stat.supportUsername }})
								</span>
							</li>

							<li>
								ID оплаты
								<span class="badge badge-pill badge-success">
									{{ stat.transactionId }}
								</span>
							</li>

							<li>
								Типа возврата
								<span class="badge badge-pill badge-success">
									{{ 'adminstat.support.return paid.' + stat.opts.type | translate }}
								</span>
								
							</li>

							<li>
								Сумма возврата
								<span class="badge badge-pill badge-success">
									${{ stat.opts.amount || stat.usdAmount }}
								</span>
							</li>

							<li>
								Оставить тарифа
								<span class="badge badge-pill badge-success">
									{{ (stat.opts.stayTariff === 'manual' ? stat.opts.dateTo : ('adminstat.support.return paid.' + stat.opts.stayTariff | translate)) }}
								</span>
							</li>

							<li>
								Коментарий
								<span *ngIf="stat.opts.comment.length < 30; else comment_in_tooltip" class="badge badge-pill badge-success">
									{{ stat.opts.comment }}
								</span>
								<ng-template #comment_in_tooltip>
									<span class="badge badge-pill badge-success" ngbTooltip="{{stat.opts.comment}}" tooltipClass="tooltip-custom-class">
										{{ stat.opts.comment.substring(0, 30) + '&#8230;&nbsp;'}}<i class="far fa-comment-alt"></i>
									</span>
								</ng-template>
							</li>
						</ul>
					</td>
				</tr>
			</tbody>
		</table>
	</section>
</article>
